import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-left",
  "use": "arrow-left-usage",
  "viewBox": "0 0 27.4 20.3",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 27.4 20.3\" id=\"arrow-left\"><g fill=\"none\" stroke-width=\"3\" stroke-miterlimit=\"10\"><path d=\"M11.3 19.3l-9.2-9.1 9.2-9.1M27.4 10.2H2\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol